import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { updateShipments } from '../../redux/actions/purchaseOrders';
import { assignmentUpdate } from '../../redux/actions/assignments';

const UpdateSupplierAssignmentModal = ({ payload, 
  supplier, 
  modalProductId,
  modalVariationId,
  modalOptions,
  modalProductName,
  modalType,
  modalAssignment,
  showUpdateSupplierAssignmentModal, 
  setShowUpdateSupplierAssignmentModal,
  updateAssignment,
  settings,
  accountUnits,
  modalY
}) => {

  const [supplierSku, setSupplierSku] = useState(null);
  const [supplierPrice, setSupplierPrice] = useState(null);
  const [minimumQuantity, setMinimumQuantity] = useState(null);
  const [orderMultiple, setOrderMultiple] = useState(null);
  const [packQuantity, setPackQuantity] = useState(null);

  const changeSku = (event) => {
    let value = event.target.value;
    setSupplierSku(value);
  }

  const changePrice = (event) => {
    let value = event.target.value.replace(/[^\d.-]+/g, '');;
    setSupplierPrice(value);
  }

  const changeOrderMultiple = (event) => {
    let value = parseInt(event.target.value).toString();
    setOrderMultiple(value);
  }

  const changePackQuantity = (event) => {
    let value = parseInt(event.target.value).toString();
    setPackQuantity(value);
  }

  const changeMinimum = (event) => {
    let value = parseInt(event.target.value);
    setMinimumQuantity(value);
  }

  const update = () => {
    let assignment = {
      product_id: modalProductId,
      variation_id: modalVariationId
    }

    // let min = minimumQuantity.toString()

    let min = modalAssignment.minimum_order;

    if(minimumQuantity) {
      min = minimumQuantity.toString();
    }

    let packQuant = modalAssignment.pack_quantity;

    if(settings?.settings?.pack_quantities && packQuantity) {
      console.log(packQuantity);
      console.log(packQuantity.toString());

      packQuant = packQuantity.toString();
    }

    let assignmentValues = {
      supplierSku: (supplierSku || modalAssignment.supplier_sku),
      supplierPrice: (supplierPrice || modalAssignment.supplier_price),
      minOrder: min,
      packQuantity: packQuant,
      orderMultiple: (orderMultiple || modalAssignment.order_multiple)
    }

    updateAssignment(payload, supplier.id, assignment, assignmentValues);
    setShowUpdateSupplierAssignmentModal(false);
  }

  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }

  return(
    <div className="main-overlay">
      <div style={{ top: `${modalY}px`, position: 'fixed' }} className="main-popup popup-center-always main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => setShowUpdateSupplierAssignmentModal(false)}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">

            <h3><strong>Supplier</strong>: { supplier.supplier_name }</h3>
            <h3><strong>Product</strong>: {modalProductName}</h3>

            { modalOptions && modalOptions.map(option =>
                <li>
                  <strong>{ option.name }</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ option.value }</span>
                </li>
              )
            }

            <p>
              <strong>Current Supplier SKU</strong>: {modalAssignment.supplier_sku}<br/>
              <strong>Current Supplier Price</strong>: {modalAssignment.supplier_price ? format(modalAssignment.supplier_price) : ''}<br/>
              <strong>Current MOQ</strong>: {modalAssignment.minimum_order}
              { settings?.settings?.order_multiples &&
                <><br/>Current Order Multiple: {modalAssignment.order_multiple}</>
              }
              { settings?.settings?.pack_quantities &&
                <><br/>Current Pack Quantity: {modalAssignment.pack_quantity}</>
              } 
            </p>

            <div className="fieldset">
              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Supplier SKU</label>
                <input type="text" value={supplierSku} onFocus={focus} onBlur={blur} placeholder={modalAssignment.supplier_sku} onChange={(e) => changeSku(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">Supplier SKU</div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Supplier Price</label>
                <input type="number" value={supplierPrice} onFocus={focus} onBlur={blur} placeholder={modalAssignment.supplier_price} onChange={(e) => changePrice(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">Supplier Price</div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Minimum Quantity</label>
                <input type="number" value={minimumQuantity} onFocus={focus} onBlur={blur} placeholder={modalAssignment.minimum_order} onChange={(e) => changeMinimum(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">Minimum Quantity</div>
              </div>

              { settings?.settings?.order_multiples &&
                <div className="field field--medium field--filled">
                  <span className="fieldset__svg-icon"></span>
                  <label className="field__label">Order Multiple</label>
                  <input type="number" value={orderMultiple} onFocus={focus} onBlur={blur} placeholder={modalAssignment.order_multiple} onChange={(e) => changeOrderMultiple(e)} className="field__input" tabindex="4" maxlength="64" />
                  <div className="field__placeholder">Order Multiple</div>
                </div>
              }

              { settings?.settings?.pack_quantities &&
                <div className="field field--medium field--filled">
                  <span className="fieldset__svg-icon"></span>
                  <label className="field__label">Pack Quantity</label>
                  <input type="number" value={packQuantity} onFocus={focus} onBlur={blur} placeholder={modalAssignment.pack_quantity} onChange={(e) => changePackQuantity(e)} className="field__input" tabindex="4" maxlength="64" />
                  <div className="field__placeholder">Pack Quantity</div>
                </div>
              }

            </div>

            <button className="bottom-5 btn btn-primary btn-medium" onClick={() => update()}>Update Assignment</button>
          </div>
        </div>
      </div>
    </div>
  )


}

const mapStateToProps = state => ({
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  updateAssignment: (payload, supplierId, assignment, assignmentValues) => dispatch(assignmentUpdate(payload, supplierId, assignment, assignmentValues)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSupplierAssignmentModal);
